import script from "./BillIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./BillIndex.vue?vue&type=script&setup=true&lang=js"

import "./BillIndex.vue?vue&type=style&index=0&id=11808db4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11808db4"]])

export default __exports__